import { Link } from "react-router-dom";
import Layout from "@/components/Layout";

export default function Login() {
  return (
    <Layout>
      <section className="container-msis py-20">
        <div className="overline mb-3">Login</div>
        <h1 className="font-display font-bold text-3xl sm:text-4xl tracking-tighter">Choose your portal.</h1>
        <div className="grid sm:grid-cols-2 gap-px bg-border mt-10 max-w-3xl">
          <Link to="/take-test" className="bg-white p-8 hover:bg-subtle" data-testid="login-student-card">
            <div className="overline">Students</div>
            <div className="font-display font-bold text-xl mt-2">Take the Test</div>
            <div className="text-sm text-slate2 mt-1">Use your Test ID and email to begin or resume your assessment.</div>
          </Link>
          <Link to="/institution/dashboard" className="bg-white p-8 hover:bg-subtle" data-testid="login-institution-card">
            <div className="overline">Institutions</div>
            <div className="font-display font-bold text-xl mt-2">Institution Portal</div>
            <div className="text-sm text-slate2 mt-1">Log in with your institution credentials to manage tests and reports.</div>
          </Link>
        </div>
        <div className="mt-6">
          <Link to="/admin/login" className="text-sm text-slate2 hover:text-navy" data-testid="login-admin-link">Admin login →</Link>
        </div>
      </section>
    </Layout>
  );
}
